/** Тип этикетки. */
export enum TemplateLabelType {
    /** Этикетки товара. */
    GoodLabel = "good-label",
}
